/**
 * Auto-rotate between the Weather and Sensors tabs.
 *
 * Rotation advances on a timer, pauses as soon as the user interacts with the
 * screen, and resumes automatically after a period of inactivity.
 */

const ROTATE_TABS = ['content-weather', 'content-sensors'];
const ROTATE_INTERVAL_MS = 20000; // advance every 20s
const RESUME_AFTER_MS = 60000; // resume 60s after the last interaction

let rotateTimer = null;
let inactivityTimer = null;
let currentIndex = 0;
let paused = false;

/**
 * Select a tab by panel id via Foundation, ignoring errors if it isn't ready.
 * @param {string} panelId - Tabs panel id
 */
function selectTab(panelId) {
  try {
    jQuery('#content-tabs').foundation('selectTab', panelId);
  } catch {
    // Foundation not initialized or tab missing — nothing to do
  }
}

/**
 * Advance to the next tab in the rotation (unless paused).
 */
function advance() {
  if (paused) {
    return;
  }
  currentIndex = (currentIndex + 1) % ROTATE_TABS.length;
  selectTab(ROTATE_TABS[currentIndex]);
}

/**
 * Pause rotation on interaction and schedule a resume after inactivity.
 */
function handleInteraction() {
  paused = true;

  if (inactivityTimer) {
    clearTimeout(inactivityTimer);
  }

  inactivityTimer = setTimeout(() => {
    paused = false;
  }, RESUME_AFTER_MS);
}

/**
 * Start auto-rotation and wire up interaction listeners.
 */
export function initAutoRotate() {
  if (rotateTimer) {
    return;
  }

  rotateTimer = setInterval(advance, ROTATE_INTERVAL_MS);

  // pointerdown covers both mouse and touch presses without the noise of
  // mousemove; wheel/keydown catch scrolling and keyboard use.
  ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach((evt) => {
    document.addEventListener(evt, handleInteraction, { passive: true });
  });
}
